import { createApiRef } from '@backstage/core-plugin-api';
import { Layer } from '../types';

export const citymapApiRef = createApiRef<CitymapApi>({
  id: 'plugin.citymap.service',
});

export interface CitymapApi {
  getLayers(): Promise<Layer[]>;
};